module.exports = __webpack_public_path__ + "static/media/ic_message_green.5100e005.svg";